import { Navigate, useParams } from "react-router-dom";

import { PermissionsEnum } from "@/auth/interfaces";
import { ROUTER_PATHS, useCheckPermissionsArray } from "@/shared";
import { useGetResponsablev2 } from "@/shared/actions/erp/responsablev2.actions";
import { LoaderComponent } from "@/shared/components/ui";
import { SaveResponsablev2 } from "../../shared/components";

export type UpdateResponsablev2PageProps = {};

const UpdateResponsablev2Page: React.FC<
  UpdateResponsablev2PageProps
> = () => {
  useCheckPermissionsArray([
    PermissionsEnum.api_change_responsable,
  ]);

  const { id } = useParams();

  const { data, isLoading } = useGetResponsablev2(id!);

  if (isLoading) return <LoaderComponent />;

  if (!data?.data?.id_responsable)
    return (
      <Navigate
        to={ROUTER_PATHS.administration.responsableNav}
      />
    );

  return (
    <SaveResponsablev2
      titlePage="Editar Responsable"
      responsableEditar={data.data}
    />
  );
};

export default UpdateResponsablev2Page;